import media from "@/utils/media";
import styled from "styled-components";

const Divider = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1px solid #dddddd;
  margin: ${(props) => (props.haveMargin ? "16px 0" : "0")};
`;

export default Divider;
